import {
  getMetricsV2,
  getUsageV2,
  getCompletenessV2,
  getCompletenessPercentageByBookV2,
} from "../service/service";

/**
 * getMetrics with fallback: tries IES id, then Sponte id
 */
export function getMetricsWithFallback(userId, exerciseId, tenant) {
  return getMetricsV2(userId, exerciseId, tenant);
}

/**
 * getUsage with fallback: tries IES id, then Sponte id
 */
export function getUsageWithFallback(userId, lessonId, tenant) {
  return getUsageV2(userId, lessonId, tenant);
}

/**
 * getCompleteness with fallback: tries IES id, then Sponte id
 */
export function getCompletenessWithFallback(userId, batchId, tenant) {
  return getCompletenessV2(userId, batchId, tenant);
}

/**
 * getCompletenessPercentageByBook with fallback: tries IES id, then Sponte id
 */
export function getCompletenessPercentageByBookWithFallback(
  tenant,
  userId,
  bookId,
  totalLessonsCount,
) {
  return getCompletenessPercentageByBookV2(
    tenant,
    userId,
    bookId,
    totalLessonsCount,
  );
}
